import React, { useState, useEffect } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import {
  Button,
  Grid,
  Icon,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import dayjs from "dayjs";
import { fetchData } from "./js/main";
import LinearProgress from "@mui/material/LinearProgress";
import { conf } from "./const";

function getBills(form) {
  return new Promise(async (resolve) => {
    let fromDate = moment(form.fromDate).format("YYYY-MM-DD");
    let toDate = moment(form.toDate).format("YYYY-MM-DD");
    fromDate += "T00:00+07:00";
    toDate += "T24:00+07:00";
    let match = {
      $and: [
        { transactionDateandTime: { $gte: fromDate } },
        { transactionDateandTime: { $lte: toDate } },
      ],
    };
    let options = {
      sort: { transactionDateandTime: 1, bill_id: 1 },
      match,
      limit: 0,
    };
    let Bills = await fetchData("post", "/v3/bill/report", options);
    resolve(Bills);
  });
}

const tableHeads = [
  { label: "วันที่" },
  { label: "ใบเสร็จเลขที่" },
  { label: "ถึงใบเสร็จเลขที่" },
  { label: "จำนวนใบเสร็จที่ใช้" },
  { label: "จำนวนใบเสร็จที่ยกเลิก" },
  { label: "ยกเลิกใบเสร็จเลขที่" },
];

export default function RptUsage(props) {
  const [form, setForm] = useState();
  const [bills, setBills] = useState();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (props.profile) {
      const dt = new Date();
      setForm({
        fromDate: dt,
        // fromDate: new Date("2023-12-06"),
        toDate: dt,
      });
    }
  }, [props]);
  useEffect(() => {
    (async () => {
      if (form) {
        setLoading(true);
        let bills = await getBills(form);
        setBills(bills);
        setLoading(false);
      }
    })();
  }, [form]);

  async function print(report) {
    let print = {
      headers: [
        { label: "รายงานการใช้ใบเสร็จ" },
        {
          label: `ตั้งแต่ ${moment(form.fromDate).format(
            "DD MMMM YYYY"
          )} ถึง ${moment(form.toDate).format("DD MMMM YYYY")}`,
        },
      ],
      table: {
        cols: tableHeads,
        rows: [],
        total: {
          col_3: 0,
          col_4: 0,
        },
      },
    };
    for (let row of report) {
      let col_5 = await row.bills
        .filter((j) => j.canceled.status === true)
        .map((bill) => {
          return bill.bill_id;
        });
      let col_3 = row.bills.length;
      let col_4 = row.bills.filter((j) => j.canceled.status === true).length;
      print.table.rows.push({
        col_0: row.bill_date,
        col_1: row.bills[0].bill_id,
        col_2: row.bills[row.bills.length - 1].bill_id,
        col_3,
        col_4,
        col_5,
      });
      print.table.total.col_3 += col_3;
      print.table.total.col_4 += col_4;
    }
    let cookie = JSON.parse(localStorage.getItem(conf.cookiePrint));
    if (!cookie) cookie = { print: {} };
    cookie.print = print;
    localStorage.setItem(conf.cookiePrint, JSON.stringify(cookie));
    document.getElementById("printFrame").src =
      process.env.PUBLIC_URL + "/print/usage";
  }
  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />
      {form && (
        <>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2} sx={{ marginTop: "15px" }}>
              <Grid item xs={12} md={3}>
                <DatePicker
                  format="DD MMM YYYY"
                  onChange={(newValue) =>
                    setForm({ ...form, fromDate: new Date(newValue) })
                  }
                  label="Form Date"
                  value={dayjs(form.fromDate)}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      fullWidth: true,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <DatePicker
                  format="DD MMM YYYY"
                  onChange={(newValue) =>
                    setForm({ ...form, toDate: new Date(newValue) })
                  }
                  label="To Date"
                  value={dayjs(form.toDate)}
                  slotProps={{
                    textField: {
                      InputLabelProps: { shrink: true },
                      fullWidth: true,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
          <br />
        </>
      )}
      {bills && (
        <div style={{ margin: "5px auto 15px" }}>
          <ReportTable bills={bills.result} loading={loading} onPrint={print} />
        </div>
      )}
    </div>
  );
}
function ReportTable({ bills, loading, onPrint }) {
  const [report, setReport] = useState();
  useEffect(() => {
    function getBillVersion(bill_id) {
      return new Promise(async (resolve) => {
        let arr = bill_id.split("-");
        if (arr[2]) {
          resolve(parseInt(arr[2].charAt(0)));
        } else {
          resolve(-1);
        }
      });
    }
    (async () => {
      let report = [];
      for (const bill of bills) {
        const version = await getBillVersion(bill.bill_id);
        const bill_date = moment(bill.transactionDateandTime).format(
          "DD MMM YYYY"
        );
        let key = report.findIndex(
          (j) => j.bill_date === bill_date && j.version === version
        );
        if (key < 0) {
          report.push({
            bill_date,
            bills: [bill],
            version,
          });
        } else {
          report[key].bills.push(bill);
        }
      }
      setReport(report);
    })();
  }, [bills]);

  return (
    <div>
      {loading && <LinearProgress />}
      {report && (
        <>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {tableHeads.map((head, key) => (
                    <TableCell key={key}>{head.label}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {report.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      sx={{ lineHeight: "60px", color: "#888" }}
                      align="center"
                    >
                      No bill found
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {report.map((row, key) => (
                      <TableRow key={key}>
                        <TableCell align="center">{row.bill_date}</TableCell>
                        <TableCell align="center">
                          {row.bills[0].bill_id}
                        </TableCell>
                        <TableCell align="center">
                          {row.bills[row.bills.length - 1].bill_id}
                        </TableCell>
                        <TableCell align="center">{row.bills.length}</TableCell>
                        <TableCell align="center">
                          {
                            row.bills.filter((j) => j.canceled.status === true)
                              .length
                          }
                        </TableCell>
                        <TableCell align="center">
                          {row.bills
                            .filter((j) => j.canceled.status === true)
                            .map((bill, key) => (
                              <div key={key}>{bill.bill_id}</div>
                            ))}
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                )}
                <TableRow>
                  <TableCell colSpan={3} className="bold" align="center">
                    รวม
                  </TableCell>
                  <TableCell className="bold" align="center">
                    {bills.length}
                  </TableCell>
                  <TableCell className="bold" align="center">
                    {bills.filter((j) => j.canceled.status === true).length}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <Button
              startIcon={<Icon>print</Icon>}
              variant="contained"
              sx={{ width: "200px" }}
              onClick={() => onPrint(report)}
            >
              <div>Print</div>
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
